module.exports = __webpack_public_path__ + "img/logo-horizontal.1c557418.png";